module.exports = __webpack_public_path__ + "media/images/pc/page_common/logo/logo_decollte_white-1c5f4cbef6d84608b163b1c95c922be0.svg";